var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("span", [_vm._v(_vm._s(_vm._f("maestroParamLabel")(_vm.param)))]),
      _vm._v(" "),
      _vm._l(_vm.options, function(option, i) {
        return _c(
          "span",
          { key: "option" + i, staticClass: "option-chip caption" },
          [_vm._v("\n\t\t" + _vm._s(option) + "\n\t")]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb99b5a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb99b5a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/label.vue
// module id = null
// module chunks = 